import { pusherConnected, pusherDisconnected } from '../actions/pusher'

import { ActionTypes } from '../actions/types'
import { getType } from 'typesafe-actions'

export interface PusherState {
  cluster?: string
  appKey?: string
  channelName?: string | null
  connected: boolean
}

export const initialState = {
  connected: false,
}

export default function pusherReducer(state: PusherState = initialState, action: ActionTypes) {
  switch (action.type) {
    case getType(pusherConnected):
      const { cluster, appKey, channelName } = action.payload
      return {
        ...state,
        cluster,
        appKey,
        channelName,
        connected: true,
      }
    case getType(pusherDisconnected):
      return {
        ...state,
        channelName: null,
        connected: false,
      }
    default:
      return state
  }
}
